import * as React from "react"

import { ActionButton } from "@components"


export default function ValidateSiteButton({ handleClick, isLoading}) {

	return <ActionButton
		isLoading={isLoading}
		label="Validate Site"
		icon="square-check"
		color="success"
		onClick={handleClick}
		size="medium"
		sx={{ width: '100%'}}
	/>
}